import { render } from "./Welcome.vue?vue&type=template&id=be5426a6&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=be5426a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be5426a6"

export default script